<script setup lang="ts">
import { ref } from "vue";

const mobileOpen = ref(false);

const links = [
  { href: "#besturen", label: "Voor besturen" },
  { href: "#functies", label: "Functies" },
  { href: "#hoe-het-werkt", label: "Zo werkt het" },
  { href: "#contact", label: "Contact" },
];
</script>

<template>
  <div class="nav-wrap">
    <VAppBar elevation="0" class="nav border-b" color="secondary">
      <VContainer class="landing-container d-flex align-center ga-4">
        <a href="#top" class="d-flex align-center">
          <img src="/branding/klupz-logo.svg" alt="Klupz" class="nav__logo" />
        </a>

        <nav class="nav__links d-none d-md-flex ga-8">
          <a v-for="link in links" :key="link.href" :href="link.href">{{
            link.label
          }}</a>
        </nav>

        <VSpacer />

        <VBtn
          color="primary"
          variant="flat"
          class="d-none d-sm-flex"
          href="mailto:info@bytechnology.nl?subject=Demo%20Klupz%20aanvragen"
        >
          Demo aanvragen
        </VBtn>

        <VBtn
          class="d-md-none"
          :icon="mobileOpen ? '$close' : '$menu'"
          variant="text"
          aria-label="Menu"
          @click="mobileOpen = !mobileOpen"
        />
      </VContainer>
    </VAppBar>

    <div v-if="mobileOpen" class="nav-mobile d-md-none">
      <VContainer class="landing-container d-flex flex-column py-2">
        <a
          v-for="link in links"
          :key="link.href"
          :href="link.href"
          class="nav__mobile-link"
          @click="mobileOpen = false"
        >
          {{ link.label }}
        </a>
      </VContainer>
    </div>
  </div>
</template>

<style scoped lang="scss">
.nav-wrap {
  position: sticky;
  top: 0;
  z-index: 10;
}

.nav {
  &__logo {
    height: 28px;
    width: auto;
  }

  &__links a {
    font-size: 14.5px;
    font-weight: 600;
    color: rgb(var(--v-theme-emphasis));

    &:hover {
      color: rgb(var(--v-theme-font-color));
    }
  }
}

.nav-mobile {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgb(var(--v-theme-secondary));
  border-bottom: 1px solid rgb(var(--v-theme-border));
  box-shadow: 0 16px 32px -20px rgba(15, 23, 42, 0.35);
}

.nav__mobile-link {
  padding: 10px 4px;
  font-weight: 600;
  color: rgb(var(--v-theme-font-color));
}
</style>
